import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'mprd-email-errors',
  templateUrl: 'email-errors.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EmailErrorsComponent {
  // FIXME: Set a proper type for this
  @Input() errors: any;
}
